<template>
    <re-b-modal ref="modal" header="分批到货信息" fit-content large>
        <div class="d-flex flex-column h-100 position-relative">
            <mini-table
                class="flex-grow-1 overflow-auto"
                entity-name="sithMesInventoryReceiptReturnRecord"
                :items="records"
                :total-count="totalCount"
                read-only
                sortable
                enable-pagination
                disable-first-index-column
                need-model-fields
                @pageChange="query"
            />
        </div>
    </re-b-modal>
</template>

<script>
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
    name: "InventoryBatchArrivalInfoModal",
    components: {ReBModal, MiniTable},
    mixins: [emCommonApiMixin],
    data() {
        return {
            poItemId: null,
            records: [],
            totalCount: 0,
        };
    },
    methods: {
        show(poItemId) {
            this.poItemId = poItemId;
            this.query({pageNumber: 0, pageSize: 10});
            this.$refs.modal.showModal();
        },
        query(page = {pageNumber: 0, pageSize: 10}) {
            const form = {
                poitemIdFilter: this.poItemId,
                sortingBy: [
                    {column: "operateType", order: "asc"},
                    {column: "operateTime", order: "asc"},
                ],
                currentPage: page.pageNumber,
                numRegPag: page.pageSize,
            };
            const uri = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryReceiptReturnRecord")}/findByFilter`;
            return this.$_emApiMixin_post(uri, form).then(response => {
                this.records = response.data.list;
                this.totalCount = response.data.pagination.totalReg;
            });
        },
    },
};
</script>
